<!-- ─────────────────────────── PRODUCTION banner ─────────────────────────── -->
@if (isPrd()) {
  <div class="shell-prd-banner">
    <i class="pi pi-exclamation-triangle"></i>
    <span>PRODUCTION — changes here affect live customers.</span>
  </div>
}

<!-- ─────────────────────────── Top bar ─────────────────────────── -->
<header class="shell-topbar" [class.shell-topbar--prd]="isPrd()">
  <span class="shell-topbar__title">
    <i class="pi pi-shield"></i>
    MDT Admin
  </span>

  <div class="shell-topbar__right">
    <p-select
      [options]="envOptions"
      [ngModel]="env()"
      (onChange)="onEnvChange($event.value)"
      optionLabel="label"
      optionValue="value"
      styleClass="shell-env-select"
      appendTo="body"
    />

    <p-button
      type="button"
      icon="pi pi-question-circle"
      severity="secondary"
      [text]="true"
      [rounded]="true"
      pTooltip="Help for this screen"
      tooltipPosition="bottom"
      [routerLink]="helpRoute()"
      ariaLabel="Help for this screen"
    />

    <p-button
      type="button"
      [label]="admin()?.name ?? ''"
      icon="pi pi-user"
      severity="secondary"
      [text]="true"
      (onClick)="menu.toggle($event)"
    />
    <p-menu #menu [model]="adminMenu()" [popup]="true" appendTo="body" />
  </div>
</header>

<div class="shell-body">
  <!-- ─────────────────────────── Left nav ─────────────────────────── -->
  <nav class="shell-nav">
    <ul>
      @for (item of navItems(); track item.route) {
        @let target = navMemory.linkFor(item.route);
        <li>
          <a
            class="shell-nav__item"
            [routerLink]="target.path"
            [queryParams]="target.queryParams"
            routerLinkActive="shell-nav__item--active"
          >
            <i [class]="item.icon"></i>
            <span>{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>
  </nav>

  <!-- ─────────────────────────── Main content ─────────────────────────── -->
  <main class="shell-content">
    <router-outlet />
  </main>
</div>

<p-confirmDialog />
